const dashboard = {
  user_dash_title: 'Benutzerbereich',
  user_dash_profile: 'Profil',
  user_dash_favorites: 'Favoriten',
  user_dash_consultations: 'Beratungen',
  user_dash_compare: 'Vergleichen',
  user_dash_recommendations: 'Empfehlungen',
  user_dash_diary: 'Behandlungstagebuch',
  user_dash_notifications: 'Benachrichtigungen',
  user_dash_contracts: 'Verträge',
  user_dash_password: 'Passwort ändern',
  user_dash_logout: 'Abmelden',

  inst_dash_title: 'Einrichtungsbereich',
  inst_dash_overview: 'Übersicht',
  inst_dash_profile: 'Einrichtungsprofil',
  inst_dash_appointments: 'Terminverwaltung',
  inst_dash_analytics: 'Analytik',
  inst_dash_membership: 'Mitgliedschaft',
  inst_dash_contracts: 'Verträge',
  inst_dash_reconciliation: 'Abstimmung',
  inst_dash_notifications: 'Benachrichtigungen',
  inst_dash_logout: 'Abmelden',

  admin_dash_title: 'Adminbereich',
  admin_dash_overview: 'Übersicht',
  admin_dash_institutions: 'Einrichtungsverwaltung',
  admin_dash_users: 'Benutzerverwaltung',
  admin_dash_consultations: 'Beratungen',
  admin_dash_contracts: 'Vertragsverwaltung',
  admin_dash_packages: 'Paketverwaltung',
  admin_dash_stats: 'Statistiken',
  admin_dash_reports: 'Berichte',
  admin_dash_settings: 'Einstellungen',
  admin_dash_logout: 'Abmelden',

  user_dash_welcome: 'Willkommen, {{name}}',
  user_dash_tab_profile: 'Profil & Benachrichtigungen',
  user_dash_tab_consultations: 'Meine Beratungsanfragen',
  user_dash_tab_contracts: 'Meine Verträge',
  user_dash_tab_password: 'Passwort ändern',
  user_dash_loading: 'Sitzung wird überprüft...',
  user_dash_remember_me: 'Angemeldet bleiben',
  user_dash_back_to_login: 'Zurück zur Anmeldeseite',
  user_dash_forgot_title: 'Passwort vergessen',
  user_dash_forgot_desc: 'Geben Sie Ihre registrierte E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen des Passworts.',
  user_dash_forgot_send: 'Link zum Zurücksetzen senden',
  user_dash_forgot_sending: 'Wird gesendet...',
  user_dash_forgot_sent_title: 'E-Mail gesendet!',
  user_dash_forgot_sent_desc: 'Ein Link zum Zurücksetzen des Passworts wurde an <strong>{{email}}</strong> gesendet.',
  user_dash_forgot_spam: 'Wenn Sie die E-Mail nicht finden, überprüfen Sie Ihren Spam-Ordner.',
  user_dash_back_to_login_btn: 'Zurück zur Anmeldung',
  user_dash_login_title: 'Benutzeranmeldung',
  user_dash_login_desc: 'Verwalten Sie Ihr Konto und sehen Sie Ihre Verträge ein',
  user_dash_fill_all: 'Bitte füllen Sie alle Felder aus',
  user_dash_login_failed: 'Anmeldung fehlgeschlagen',
  user_dash_no_account: 'Kein Konto?',
  user_dash_register: 'Registrieren',
  email_change_title: 'E-Mail-Änderung',
  email_change_subtitle: 'Ihre Anmeldedaten werden aktualisiert',
  email_change_desc: 'Sie ändern Ihre E-Mail-Adresse zu <strong>{{email}}</strong>.',
  email_change_warning: 'Nach dieser Änderung müssen Sie sich mit Ihrer <strong>neuen E-Mail-Adresse</strong> anmelden.',
  email_change_confirm: 'Ja, aktualisieren',
  email_change_saving: 'Wird gespeichert...',
  email_change_cancel: 'Abbrechen',
  profile_user_id: 'Benutzer-ID',
  profile_copy: 'Kopieren',
  profile_copied: 'Kopiert!',
  profile_title: 'Profilinformationen',
  profile_saved: 'Änderungen gespeichert.',
  profile_gender: 'Geschlecht',
  profile_male: 'Männlich',
  profile_female: 'Weiblich',
  profile_other: 'Keine Angabe',
  profile_first_name: 'Vorname',
  profile_last_name: 'Nachname',
  profile_email: 'E-Mail',
  profile_phone: 'Telefon',
  profile_country: 'Land',
  profile_country_placeholder: 'Land auswählen',
  profile_city: 'Stadt',
  profile_city_placeholder: 'Stadt auswählen',
  profile_city_select_country: 'Zuerst Land auswählen',
  profile_search_country: 'Land suchen...',
  profile_search_phone: 'Land oder Code suchen...',
  profile_no_result: 'Keine Ergebnisse gefunden',
  profile_save_btn: 'Änderungen speichern',
  notif_title: 'Benachrichtigungseinstellungen',
  notif_desc: 'Wählen Sie, welche Benachrichtigungen Sie erhalten möchten',
  notif_saved: 'Benachrichtigungseinstellungen gespeichert.',
  notif_email_consult: 'Beratungsanfrage E-Mail-Benachrichtigung',
  notif_email_consult_desc: 'E-Mail erhalten, wenn sich der Anfragestatus ändert',
  notif_email_newsletter: 'Newsletter-E-Mails',
  notif_email_newsletter_desc: 'Über Entwicklungen im Gesundheitstourismus informiert bleiben',
  notif_sms_consult: 'SMS-Benachrichtigung',
  notif_sms_consult_desc: 'SMS erhalten, wenn Beratungsanfrage genehmigt wird',
  notif_sms_reminder: 'Erinnerungsbenachrichtigungen',
  notif_sms_reminder_desc: 'Erinnerung vor der Beratung erhalten',
  notif_save_btn: 'Einstellungen speichern',
  pwd_title: 'Passwort ändern',
  pwd_saved: 'Ihr Passwort wurde erfolgreich geändert.',
  pwd_current: 'Aktuelles Passwort',
  pwd_new: 'Neues Passwort',
  pwd_new_placeholder: 'Mindestens 6 Zeichen',
  pwd_confirm: 'Neues Passwort bestätigen',
  pwd_confirm_placeholder: 'Passwort erneut eingeben',
  pwd_mismatch: 'Passwörter stimmen nicht überein',
  pwd_submit: 'Passwort ändern',
  pwd_verifying: 'Wird überprüft...',
  pwd_strength_weak: 'Schwach',
  pwd_strength_medium: 'Mittel',
  pwd_strength_strong: 'Stark',
  pwd_err_current: 'Aktuelles Passwort eingeben',
  pwd_err_min: 'Neues Passwort muss mindestens 6 Zeichen haben',
  pwd_err_mismatch: 'Neue Passwörter stimmen nicht überein',
  pwd_err_same: 'Neues Passwort darf nicht dasselbe wie das aktuelle sein',
  pwd_err_unexpected: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
  consult_tab_loading: 'Wird geladen...',
  consult_tab_empty: 'Sie haben noch keine Beratungsanfragen',
  consult_tab_explore: 'Einrichtungen erkunden',
  consult_tab_cancel: 'Abbrechen',
  consult_tab_cancel_confirm: 'Sind Sie sicher, dass Sie diese Beratungsanfrage stornieren möchten?',
  consult_tab_cancelled: 'Beratungsanfrage storniert',
  consult_tab_cancel_failed: 'Stornierung fehlgeschlagen',
  consult_tab_evaluate: 'Bewerten',
  consult_tab_view_inst: 'Einrichtung anzeigen',
  consult_tab_appt_info: 'Termininformationen',
  consult_tab_appt_date: 'Datum',
  consult_tab_appt_note: 'Notiz',
  consult_tab_review_title: 'Bewertung schreiben',
  consult_tab_review_rating: 'Ihre Bewertung',
  consult_tab_review_comment: 'Ihr Kommentar',
  consult_tab_review_comment_ph: 'Teilen Sie Ihre Erfahrung...',
  consult_tab_review_recommend: 'Ich empfehle diese Einrichtung',
  consult_tab_review_submit: 'Absenden',
  consult_tab_review_cancel: 'Abbrechen',
  consult_tab_review_sent: 'Ihre Bewertung wurde eingereicht und wird nach Genehmigung veröffentlicht',
  consult_tab_review_failed: 'Bewertung konnte nicht eingereicht werden',
  consult_tab_load_failed: 'Beratungsanfragen konnten nicht geladen werden',
  consult_tab_status_waiting: 'Wartend',
  consult_tab_status_appointed: 'Termin vergeben',
  consult_tab_status_completed: 'Abgeschlossen',
  consult_tab_status_cancelled: 'Storniert',
  consult_tab_status_rejected: 'Abgelehnt',
  contracts_title: 'Meine Verträge',
  contracts_desc: 'Sie können die von Ihnen genehmigten Verträge und ihre aktuellen Versionen einsehen.',
  contracts_loading: 'Wird geladen...',
  contracts_empty: 'Noch keine Verträge gefunden',
  contracts_agreed_version: 'Von Ihnen genehmigte Version',
  contracts_outdated: 'Aktuelle Version: {{version}} verfügbar',
  contracts_up_to_date: 'Sie haben die aktuelle Version genehmigt',
  contracts_not_agreed: 'Sie haben diesen Vertrag noch nicht genehmigt',
  contracts_current_version: 'Aktuelle Version',
  contracts_effective_date: 'Gültigkeitsdatum',
  contracts_view_full: 'Vollständigen Inhalt anzeigen',
  contracts_close: 'Schließen',
  contracts_version_label: 'Version',
  contracts_type_user_terms: 'Website-Mitgliedschafts- und Nutzungsvertrag',
  contracts_type_user_kvkk: 'KVKK-Zustimmungsvertrag',
  contracts_type_user_marketing: 'Marketingkommunikationsvertrag',
  login_email: 'E-Mail',
  login_password: 'Passwort',
  login_submit: 'Anmelden',
  login_logging_in: 'Wird angemeldet...',
  login_error: 'Ungültige E-Mail oder Passwort.',
  login_forgot_password: 'Passwort vergessen?',
  login_no_account: 'Kein Konto?',
  login_register: 'Registrieren',
  login_user_title: 'Benutzeranmeldung',
  login_institution_title: 'Einrichtungsanmeldung',
  login_admin_title: 'Admin-Anmeldung',
};

export default dashboard;
